import React from 'react';
import { images } from '../data/mock';
import { Calendar, ArrowRight, CreditCard } from 'lucide-react';

const NewFooter = () => {
  const currentYear = new Date().getFullYear();
  const ctaLink = "https://calendly.com/davwaysolution/review";

  return (
    <footer style={{ backgroundColor: '#0B1F3A', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Logo and tagline */}
          <div>
            <img 
              src={images.logo} 
              alt="Davway Solutions" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400">
              Helping businesses eliminate card processing fees and keep more of their hard-earned money.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#calculator" className="text-gray-400 hover:text-white transition-colors">Profit Calculator</a></li>
              <li><a href="#features" className="text-gray-400 hover:text-white transition-colors">Features</a></li>
              <li><a href="#how-it-works" className="text-gray-400 hover:text-white transition-colors">How It Works</a></li>
              <li><a href="#testimonials" className="text-gray-400 hover:text-white transition-colors">Reviews</a></li>
              <li><a href="/quick-check" className="text-gray-400 hover:text-white transition-colors">Quick Payment Check</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-right">
            <h4 className="text-white font-semibold mb-4">Have Questions?</h4>
            <p className="text-gray-400 mb-4">
              For all questions, schedule a call for a direct answer.
            </p>
            <div>
              <a 
                href={ctaLink} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 group"
                style={{ backgroundColor: '#22C55E' }}
              >
                <Calendar size={18} />
                Schedule a Call
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Davway Solutions. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-gray-500 text-sm mt-2 md:mt-0">
            <CreditCard size={16} style={{ color: '#D4AF37' }} />
            <span>PCI Compliant Payment Solutions</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
